import axios from 'axios'
import Vue from 'vue'
import * as constant from '../constant'
import router from '../router'


// 白名单接口列表
const arr = [
  '/student-consumer/api/examResults/getCaptchaImage',
  '/student-consumer/api/examResults/getPersonResults',
  '/student-consumer/api/examResults/getExamResultsTitle',
  '/student-consumer/api/file/uploadFaceImageToOss',
  '/student-consumer/api/textMessage/sendVerificationCodeMessage',
  '/auth/api/autoLogin',
  '/auth/api/bindLogin',
  '/auth/cas/login',   // cas登录接口
  '/student-consumer/api/visitor/getAuditVisitorDetailsNotice',
  '/student-consumer/api/visitor/getAuditStaffVisitorDetailsNotice',
  '/student-consumer/api/identifyNotice/getIdentifyNotice',
  '/student-consumer/api/identifyNotice/getIdentifyNotice',
  '/student-consumer/api/robotDetect/getRobotDetectById',
  '/student-consumer/api/schoolcarwarning/getSchoolCarWarningByIdMini'
]
// 统一服务认证平台地址 (正式)
let baseCas = 'https://sso.jnpec.edu.cn/login?service='
// 统一服务认证平台地址 (测试)
// let baseCas = 'http://192.168.10.40:8443/cas/login?service='



// cas接口列表
const room_intreface = [
  '/student-consumer/api/activity/app/appointmentApplication',
  'student-consumer/api/activity/audit/appointmentApproval'
]



// 企业微信调用接口
const wxComArr = [
  '/auth/api/getUserTokenByWxCpUserId'   // 企业获取用户信息接口
]


// 访客系统页面
const wxCom_router = [
  '/subscribeQy', '/approvalQy', '/visited-historyQy', '/visNoticeDetailQy', '/detailSubQy', '/approvalNoticeDetailQy', '/profileQy'
]

// 活动室页面路径
const room_router = [
  '/roomAppointment','/roomReservation','/roomApproval','/roomApprovalDetail','/roomReservationDetail','/roomAppointRecord'
]


const instance = axios.create({
  baseURL: `${constant.baseUrl}`,
  timeout: 15000,
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.url.indexOf('getStudentByPhone') !== -1 || config.url.indexOf('student-consumer') !== -1 || config.url.includes('getSysDictDataListByDictType') || config.url.includes('auth')) {
      // config.baseURL='https://ai-test-api.asiait.net/college/';      //本地测试地址
      config.baseURL='https://sca.jnpec.edu.cn/api'   // 线上地址

      // config.baseURL = 'https://ai-test-api.asiait.net/api/' // 线上测试地址
      // config.baseURL = 'https://ai-prod.asiait.net/api/' 
      // config.baseURL = 'http://192.168.10.35:8097'

    } else if (config.url.includes('/visitors/getVisitor')) {
      // config.baseURL='https://ai-test-api.asiait.net/college/'       //本地测试地址
      config.baseURL='https://sca.jnpec.edu.cn/api'   // 线上地址
      // config.baseURL = 'https://ai-test-api.asiait.net/api/' // 线上测试地址
      // config.baseURL = 'https://ai-prod.asiait.net/api/'
      // config.baseURL = 'http://192.168.10.35:8097'
    } else if (config.url.includes('getVisitorListService')) {
      config.baseURL='https://sca.jnpec.edu.cn/api'    // 线上地址
      // config.baseURL='https://ai-test-api.asiait.net/college/'       //本地测试地址
      // config.baseURL = 'https://ai-test-api.asiait.net/api/' // 线上测试地址
      // config.baseURL = 'https://ai-prod.asiait.net/api/'
      // config.baseURL = 'http://192.168.10.35:8097'
    } else {
      config.baseURL='https://sca.jnpec.edu.cn/api';    //线上地址
      // // config.baseURL='https://ai-test-api.asiait.net/college/';               //本地测试地址
      // config.baseURL = 'https://ai-test-api.asiait.net/api/'  //线上测试地址
      // config.baseURL = 'https://ai-prod.asiait.net/api/'
      // config.baseURL = 'http://192.168.10.35:8097'
    }
    // console.log(config.url)
    if (config.url && config.url[0] !== '/') {
      config.url = '/' + config.url
    }


    // 排除白名单接口
    if (!arr.includes(config.url) && !wxComArr.includes(config.url.split('?')[0]) && !wxCom_router.includes(router.history.current.path)) {
      localStorage.getItem('token') && (config.headers.Authorization = localStorage.getItem('token'))
    }



    // 添加企业微信登录传递的token
    if ((!arr.includes(config.url) && wxComArr.includes(config.url.split('?')[0])) || (wxCom_router.includes(router.history.current.path) && !arr.includes(config.url))) {
      localStorage.getItem('wxCom_token') && (config.headers.Authorization = localStorage.getItem('wxCom_token'))
    }

    // 添加统一认证平台登录token ()
    if (room_intreface.includes(config.url)) {
        localStorage.getItem('cas_token') && (config.headers.Authorization = localStorage.getItem('cas_token'))
    }
    
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)
// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    let code = response.data.code
    if (response.status === 200) {
      // 判断活动室token是否过期
      if (code == 401 && room_router.includes(router.history.current.path)) {
        // window.location.href = baseCas + 'http://lvyushui.frp.asiait.net/casLogin' // 测试
        window.location.href = baseCas + 'https://sca.jnpec.edu.cn/mobile/casLogin' // 正式
      }
      return Promise.resolve(response.data)
    } 
  },
  (err) => {
    console.log('err',err)
    if (err.message.includes('timeout')) {
      Vue.prototype.$toast('请求超时了，请重试')
    }
    let msg = ''

    switch (err.response.status) {
      case 401:
        msg = '您没有权限访问当前资源'
        break
      case 403:
        msg = '您的请求被拒绝，请联系管理员'
        break
      case 404:
        msg = '访问的资源不存在'
        break
      case 500:
        msg = '服务器出错了，请联系管理员'
        break
      default:
        msg = '服务器出错了，请联系管理员'
    }
    Vue.prototype.$toast(msg)
    console.log(err)
    return Promise.reject(err)
  }
)

export function get(url, data) {
  return instance({ url, params: data, method: 'get' })
}

export function post(url, data) {
  return instance({ url, data, method: 'post' })
}

export function upload(url, data) {
  return instance({
    url,
    data,
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export default instance
